

interface Feature {
  icon: string;
  description: string;
  metric: string;
  alt: string;
}

const featuresData: Feature[] = [
  {
    icon: "https://assets.cars24.com/production/c2b-website/250924150348/js/65d0db9d810669569349186eddb1fb65.svg",
    description: "Profit Potential of Up to",
    metric: "5L/month",
    alt: "Rupee icon representing profit potential",
  },
  {
    icon: "https://assets.cars24.com/production/c2b-website/250924150348/js/6c72cb058dcdecc47d8411f83f0c4719.svg",
    description: "Used car market growth of",
    metric: "20% Yearly",
    alt: "Graph arrow icon representing market growth",
  },
  {
    icon: "https://assets.cars24.com/production/c2b-website/250924150348/js/b5b63fc29812690e99ad01b92e955212.svg",
    description: "Access to a network of",
    metric: "20,000+ Dealers",
    alt: "Network icon representing dealer access",
  },
  {
    icon: "https://assets.cars24.com/production/c2b-website/250924150348/js/e5271d949ae7288d2278e3ca285f11db.svg",
    description: "Trusted brand: annually catering",
    metric: "2L Sellers",
    alt: "Checkmark in a circle icon representing a trusted brand",
  },
  {
    icon: "https://assets.cars24.com/production/c2b-website/250924150348/js/cd378984b1d3ac925f5e2744faca8470.svg",
    description: "Return of investment in",
    metric: "3 Months",
    alt: "Heart with a cycle arrow icon representing return of investment",
  },
  {
    icon: "https://assets.cars24.com/production/c2b-website/250924150348/js/2f2a515284a2c51370caa9380685022f.svg",
    description: "Diversify your income via",
    metric: "10+ Services",
    alt: "Grid icon representing diverse services",
  },
];

const FeatureCard = ({ icon, description, metric, alt }: Feature) => (
  <div className="bg-secondary p-8 rounded-lg border border-border">
    <img src={icon} alt={alt} width={64} height={64} className="mb-4" />
    <div className="text-base text-text-secondary mb-2">{description}</div>
    <div className="text-2xl font-semibold text-text-primary">{metric}</div>
  </div>
);

const WhyFranchise = () => {
  return (
    <section className="bg-white py-20">
      <div className="container mx-auto px-4">
        <h2 className="mb-12">Why Carz Bazzar franchise?</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {featuresData.map((feature) => (
            <FeatureCard
              key={feature.metric}
              icon={feature.icon}
              description={feature.description}
              metric={feature.metric}
              alt={feature.alt}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyFranchise;
